import { render, staticRenderFns } from "./PlayerQueue.vue?vue&type=template&id=395fdfd2"
import script from "./PlayerQueue.vue?vue&type=script&lang=js"
export * from "./PlayerQueue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports